import { Box } from 'components/Box';
import { Divider } from 'components/Divider';
import { Flex } from 'components/Flex';
import { Hide } from 'components/Hide';
import { Icon } from 'components/Icon/Icon';
import { Text } from 'components/Text/Text';
import { SearchContextHeaderData } from 'modules/search/containers/SearchContextHeader/SearchContextHeaderData';
import { SearchContextHeaderLocationState } from 'modules/search/containers/SearchContextHeader/SearchContextHeaderLocationState';
import { trackClicked } from 'utils/analytics/track/trackClicked';

import { Link, ResultsCount } from './SearchContextHeader.styled';
import { SearchContextHeaderLinkText } from './SearchContextHeaderLinkText';
import { searchContextHeaderGetUrl } from './searchContextHeaderGetUrl';

type Props = {
  noDivider?: boolean;
  searchContext: SearchContextHeaderData;
};

export function SearchContextHeader({ noDivider, searchContext }: Props) {
  const {
    searchResultsUrl,
    searchResultsState,
    previousResult,
    previousResultPageIndex,
    nextResult,
    nextResultPageIndex,
    resultIndex,
    totalResults,
    setPageIndex,
    searchFacets,
  } = searchContext;

  const nextUrl = searchContextHeaderGetUrl(nextResult || undefined);
  const previousUrl = searchContextHeaderGetUrl(previousResult || undefined);

  return (
    <Text
      data-qa-id="search-context-header"
      fontSize="14px"
      color="lightContentGrey"
      letterSpacing=".26px"
    >
      <Flex justifyContent="space-between">
        <Link
          to={searchResultsUrl}
          state={searchResultsState}
          onClick={() =>
            trackClicked('Back To Results', {
              header_position: 'top',
            })
          }
          data-qa-id="search-context-back-to-search"
        >
          <Icon name="list" size={16} colorName="lightContentGrey" />{' '}
          <Box verticalAlign="middle" display="inline-block">
            {getText('Back to results')}
          </Box>
        </Link>
        <Flex alignItems="center">
          {previousResult ? (
            <Link
              data-qa-id="search-context-previous-result"
              to={previousUrl}
              state={
                {
                  showSearchContext: { searchFacets },
                } satisfies SearchContextHeaderLocationState
              }
              onClick={() => {
                trackClicked('Previous Listing', {
                  org_id:
                    'orgID' in previousResult
                      ? previousResult.orgID
                      : undefined,
                  org_type:
                    'orgType' in previousResult
                      ? previousResult.orgType
                      : undefined,
                  result_id: previousResult.objectID,
                  header_position: 'top',
                });

                if (previousResultPageIndex !== null) {
                  setPageIndex(previousResultPageIndex, false);
                }
              }}
            >
              <SearchContextHeaderLinkText text="previous" />
            </Link>
          ) : (
            <SearchContextHeaderLinkText text="previous" />
          )}

          <Hide xs sm>
            <ResultsCount>
              {resultIndex + 1} of {totalResults}
            </ResultsCount>
          </Hide>

          <Hide md lg xl>
            <Box mx="8px">|</Box>
          </Hide>

          {nextResult ? (
            <Link
              data-qa-id="search-context-next-result"
              to={nextUrl}
              state={
                {
                  showSearchContext: { searchFacets },
                } satisfies SearchContextHeaderLocationState
              }
              onClick={() => {
                trackClicked('Next Listing', {
                  org_id: 'orgID' in nextResult ? nextResult.orgID : undefined,
                  org_type:
                    'orgUrl' in nextResult ? nextResult.orgType : undefined,
                  result_id: nextResult.objectID,
                  header_position: 'top',
                });

                if (nextResultPageIndex !== null) {
                  setPageIndex(nextResultPageIndex, false);
                }
              }}
            >
              <SearchContextHeaderLinkText text="next" />
            </Link>
          ) : (
            <SearchContextHeaderLinkText text="next" />
          )}
        </Flex>
      </Flex>
      {!noDivider && <Divider marginTop={16} marginBottom={16} />}
    </Text>
  );
}
